import React, { useState, useEffect } from "react";
import Context from "../../Context";
import { useToast } from "../../components/ui";
import { Header } from "../../components/modules";

import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "../../components/base";
import { HiOutlineDocumentSearch } from "react-icons/hi";
import { Switch } from "../../components/ui";

import { FaPlus } from "react-icons/fa";
import {
  FiHome,
  FiShoppingBag,
  FiCreditCard,
  FiSettings,
  FiGift,
  FiUsers,
  FiUserCheck,
  FiFrown,
  FiVideo,
  FiFileText,
  FiDollarSign,
  FiSmile,
  FiShoppingCart,
} from "react-icons/fi";
import { BiLogIn } from "react-icons/bi";
import { IoReceiptOutline } from "react-icons/io5";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import constant, { statuses } from "../../constants";
import { Spinner } from "reactstrap";
import { MdLockClock } from "react-icons/md";

import {
  unixToDate,
  dateToUnix,
  roundDateToDate,
  unixToDateAndTime,
  resizeImage,
} from "../../util";
import { TimePicker, Spin } from "antd";

import th from "antd/es/date-picker/locale/th_TH";
import dayTh from "dayjs/locale/th";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import buddhistEra from "dayjs/plugin/buddhistEra";

dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

const buddhistLocale = {
  ...th,
  lang: {
    ...th.lang,
    fieldDateFormat: "DD-MM-BBBB",
    fieldDateTimeFormat: "DD-MM-BBBB HH:mm:ss",
    yearFormat: "BBBB",
    cellYearFormat: "BBBB",
  },
};

export const Tools = () => {
  const { callApi, updateConfig, configs } = Context();
  const { toast } = useToast();

  const [loading, setLoading] = useState(false);

  useEffect(() => {}, []);

  const updateChange = async (key, value) => {
    const { status } = await callApi(
      "configs-edit",
      {
        id: "general",
        key: key,
        value: value,
      },
      { notShowLoading: true }
    );

    if (status) {
      toast({
        className: "bg-[rgb(59,176,101)]",
        title: `อัพเดตข้อมูลสำเร็จ`,
      });
    } else {
      toast({
        className: "bg-[#c15b78]",
        title: `อัพเดตข้อมูลไม่สำเร็จ`,
      });
    }
  };
  return (
    <div className="h-fit min-w-[600px] w-full">
      {loading && (
        <div className="absolute w-full col-span-3 border-r border-[#E5E7E9]  z-50 h-full bg-[rgb(255,255,255,0.6)] flex items-center justify-center">
          <Spinner className="w-4 h-4" />
        </div>
      )}
      <Header
        header="Settings"
        subHeader={`เครื่องมือ`}
        icon={<FiSettings className="text-blue" />}
      />

      <div className="relative mt-3 col-span-3 rounded-lg overflow-hidden shadow-md  bg-white  min-w-48 w-full h-fit">
        <div className=" p-3 flex justify-between items-center border-b border-[#E5E7E9]">
          <p className="font-semibold">คำนวนคะแนนงวด {configs.roundDate}</p>
          <button
            className="bg-failed font-semibold text-white text-sm rounded-md py-1 px-3 hover:opacity-60 duration-150 disabled:opacity-65"
            disabled={loading}
            onClick={async () => {
              setLoading(true);
              const status = await callApi(
                "points-addRoundedPoint",
                {},
                { notShowLoading: true }
              );
              if (status) {
                toast({
                  className: "bg-[rgb(59,176,101)]",
                  title: `อัพเดตข้อมูลสำเร็จ`,
                });
              } else {
                toast({
                  className: "bg-[#c15b78]",
                  title: `อัพเดตข้อมูลไม่สำเร็จ`,
                });
              }
              setLoading(false);
            }}
          >
            เริ่มคำนวนคะแนน
          </button>
        </div>
      </div>
    </div>
  );
};
